import comp from "./GenericCheckList";
export default comp;
